import { Box, Typography } from '@mui/material';
import { FormikTextField } from '@/common/presentation/components/forms/fields/FormikTextField';
import { RaptorJobFormValues } from '../../../../RaptorJobValidationSchema';
import tid from '@/common/application/utils/tid';

export function NotesSection() {
  return (
    <>
      <Typography variant="h6" component="div" sx={{ fontSize: '1rem', mb: 2, fontWeight: 600 }}>
        Notes
      </Typography>
      <Box sx={{ display: 'flex', gap: '12px', flexDirection: { xs: 'column', sm: 'row' } }}>
        <Box sx={{ flex: 1 }}>
          <FormikTextField<RaptorJobFormValues>
            id="notesForCrew"
            label="Notes for Crew"
            multiline
            rows={4}
            placeholder="Notes for Crew"
            {...tid('jobs:create:notes-for-crew-input')}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <FormikTextField<RaptorJobFormValues>
            id="jobNotes"
            label="Job Notes"
            multiline
            rows={4}
            placeholder="Job Notes (internal only)"
            {...tid('jobs:create:job-notes-input')}
          />
        </Box>
      </Box>
    </>
  );
}
